type BlockEditorMode = 'standard' | 'advanced' | 'eduBlocks' | 'safe';

/**
 * Returns the appropriate Blockly toolbox configuration for a given editor mode.
 * This function now expects the toolbox config functions to be passed in,
 * supporting dynamic loading of block modules.
 * @param mode The desired editor mode.
 * @param configFunctions Object containing the toolbox config functions
 * @returns The Blockly toolbox configuration JSON object.
 */
export const getToolboxConfigForMode = (
  mode: BlockEditorMode,
  configFunctions: {
    getSimpleToolboxConfig: () => any;
    getAdvancedToolboxConfig: () => any;
    getEduBlocksToolboxConfig: () => any;
    getSafeToolboxConfig: () => any;
  }
) => {
  const {
    getSimpleToolboxConfig,
    getAdvancedToolboxConfig,
    getEduBlocksToolboxConfig,
    getSafeToolboxConfig
  } = configFunctions;

  switch (mode) {
    case 'standard':
      // Combines simple blocks with a few others for a standard experience.
      // In the future, this could be more customized.
      return getSimpleToolboxConfig(); 
    
    case 'advanced': {
      // The advanced toolbox includes everything from simple and advanced sets.
      // Note: This assumes no overlapping block type definitions.
      const simpleConfig = getSimpleToolboxConfig();
      const advancedConfig = getAdvancedToolboxConfig();
      return {
        ...simpleConfig,
        contents: [...simpleConfig.contents, ...advancedConfig.contents]
      };
    }

    case 'eduBlocks':
      return getEduBlocksToolboxConfig();

    case 'safe':
        return getSafeToolboxConfig();

    default:
      console.warn(`Unknown editor mode: ${mode}. Defaulting to standard toolbox.`);
      return getSimpleToolboxConfig();
  }
}; 